
$(document).on("click", ".question_product,.faq_question,.column_testimonial_heading_slider_new,.included_faq_question", function (e) {
  if (jQuery(this).hasClass("active")) {
    jQuery(this).toggleClass('active');
    jQuery(this).next().slideToggle();
  } else {
    jQuery('.question_product,.faq_question,.column_testimonial_heading_slider_new,.included_faq_question').removeClass('active');
    jQuery('.question_product,.faq_question,.column_testimonial_heading_slider_new,.included_faq_question').next().slideUp();
    jQuery(this).toggleClass('active');
    jQuery(this).next().slideToggle();
  }
});
$(document).on("click", ".custom_button", function (e) {
    var video = jQuery(this).parents('.video_wrapper_custom').find('video');
if (jQuery(this).hasClass("active")) {
   jQuery(this).parents('.video_wrapper_custom').removeClass('video-active');
    jQuery(this).removeClass('active');
video.trigger('pause');
} else {
video.trigger('play');
  jQuery(this).parents('.video_wrapper_custom').addClass('video-active');
    jQuery(this).addClass('active');
}
});






$(document).on("click", "a[href='#']", function (e) {
  e.preventDefault();
  const targetEl = document.querySelector('.landing_product_info');
  if (targetEl) {
    targetEl.scrollIntoView({ behavior: 'smooth' });
  }
});


$(document).on("click", "a[href='#benifits']", function (e) {
  e.preventDefault();
  document.querySelector('#benifits').scrollIntoView({
    behavior: 'smooth'
  })
});

$(document).on("click", "a[href='#reviews']", function (e) {
  e.preventDefault();
  document.querySelector('#reviews').scrollIntoView({
    behavior: 'smooth'
  })
});







$(document).on("click", ".tabs_main_item", function (e) {
var data_tab = $(this).attr('data_tab');
$('.tabs_main_item').removeClass('active');
$(this).addClass('active');
$('.columns_center_slider_tab').hide();
$('.columns_center_slider_tab[data_tab="'+data_tab+'"]').show();
$('.columns_center_slider_tab[data_tab="'+data_tab+'"] .slick-slider').slick('refresh');
});

$(document).on("click", ".read_more_trigger:not(.read_more_full+.read_more_trigger)", function (e) {
$(this).hide();
$(this).next().slideToggle('medium', function() {
    if ($(this).is(':visible'))
        $(this).css('display','inline');
});
$(this).next().next().slideToggle('medium', function() {
    if ($(this).is(':visible'))
        $(this).css('display','inline');
});
});
$(document).on("click", ".read_more_full+.read_more_trigger", function (e) {
$(this).hide();
$(this).prev().slideToggle('medium', function() {
    if ($(this).is(':visible'))
        $(this).css('display','inline');
});
$(this).prev().prev().slideToggle('medium', function() {
    if ($(this).is(':visible'))
        $(this).css('display','inline');
});
});



jQuery(document).ready(function(){
if(navigator.userAgent.indexOf('Mac') > 0) {
jQuery('body').addClass('mac-os');
} else {
 jQuery('body').addClass('window-os'); 
}
});





function isScrolledIntoView(elem) {
    var docViewTop = $(window).scrollTop();
    var docViewBottom = docViewTop + $(window).height();

    var elemTop = $(elem).offset().top;
    var elemBottom = elemTop + $(elem).height();

    return ((elemBottom <= docViewBottom) && (elemTop >= docViewTop));
}

$('body').scroll(function () {
    $('.custom_counter .icons_with_text_flex').each(function () {
      var this_element =  $(this);
      if (this_element.hasClass("start_count")) {
} else {
        if (isScrolledIntoView(this) === true) {
            this_element.addClass('start_count');
$('.count_js').each(function () {
    $(this).prop('Counter', 0).animate({
            Counter: $(this).data('value')
        }, {
        duration: 1000,
        easing: 'swing',
        step: function (now) {                      
            $(this).text(Math.ceil(now));
        }
    });
});
        }
      }
    });

});




$(document).on("click", '.ajax_add_cart', function(e) {
 e.preventDefault(); 
var this_element =  jQuery(this);
this_element.addClass('loading_hk');
var id = jQuery(this).attr('variant_id');
jQuery.ajax({
type: 'POST',
url: '/cart/add.js',
data: {
  quantity: 1,
  id: id
},
  dataType: 'json', 
 success: function (data) { 
$('cart-drawer').load(location.href + " #CartDrawer");
setTimeout(function() {
$('cart-drawer').removeClass('is-empty').addClass("active");
this_element.removeClass('loading_hk'); 
}, 500);
 } 
 });
  });


  $(document).on("click", '.search_trigger_button', function (e) {
var text = $(this).prev().val();
text = text.trim();
text = text.replace(" ", "+");
var link = '/search';
var new_link = link+'?q='+text;
  location.href=new_link;
});


$('.header_custom_search input').keypress(function (e) {
if (e.which == '13') {
 $(this).next().trigger('click');
}});
